import { render } from "./TVMonitor.vue?vue&type=template&id=2e655b9f&scoped=true"
import script from "./TVMonitor.vue?vue&type=script&lang=js"
export * from "./TVMonitor.vue?vue&type=script&lang=js"

import "./TVMonitor.vue?vue&type=style&index=0&id=2e655b9f&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e655b9f"]])

export default __exports__